<template>
  <div class="main">
    <div class="navigate-background" id="summit-homepage">
      <!--  大图最底下  文字放在最上面，绝对定位navigateBg@1 navigate-img-bac -->
      <!--    navigate-img-bac-en  -->
      <img
        src="../../../assets/images/navigate-img-bac-EN.png"
        class="navigate-img-1"
        ondragstart="return false;"
        v-show="!getBannerTime()"
      />
      <img
        src="../../../assets/images/bannerKV.png"
        class="navigate-img-1"
        ondragstart="return false;"
        v-show="getBannerTime()"
      />
      <div class="radio" v-show="getBannerTime()">
        <div class="muduRadioKV"></div>
        <div class="muduRadio">
          <video
            id="mudu-video"
            class="mudu-video"
            muted="muted"
            ref="videoRef"
            autoplay="autoplay"
            controls="controls"
            loop="-1"
            src="https://navigatesummit.h3c.com/webinar/2023Navigate/zhengshi/%E4%BA%91%E5%B1%8F-%E8%8B%B1%E6%96%87/%E3%80%90%E5%AE%A3%E4%BC%A0%E7%89%87%E3%80%91%E6%96%B0%E5%8D%8E%E4%B8%89%E9%9B%86%E5%9B%A22022%E5%AE%A3%E4%BC%A0%E7%89%87-%E8%8B%B1%E6%96%87%E7%89%88-16x90.mp4"
            poster="../../../assets/images/live/liveKV.png"
            style="object-fit: contain"
          ></video>
          <!--          <div id="mudu-video" ref="MuDuRef" />-->
        </div>
      </div>
      <div class="reservation" v-show="!getBannerTime()">
        <!--        <div class="left-img">-->
        <!--          <img-->
        <!--            src="../../../assets/images/navigate-EN.png"-->
        <!--            class="navigate-img"-->
        <!--            ondragstart="return false;"-->
        <!--          />-->
        <div class="reservation-btn" v-if="getTime()" @click="goToLive('5', '全体大会')">
          <span> Watch Live</span>
        </div>
        <div class="reservation-btn" v-else-if="handleEndTime()" @click="goToLive('5', '全体大会')">
          <span>Playback</span>
        </div>
        <!--    @click="handleClickReservation"    -->
        <div class="reservation-btn" v-else-if="scheduleDisable" @click="goToLive('5', '全体大会')">
          <span>Register now</span>
        </div>
        <div class="reservation-Done" v-else>
          <span class="scheduleDone" @click="goToLive('5', '全体大会')">Reserved</span>
        </div>
        <!--        </div>-->
      </div>
    </div>

    <div class="mainContent">
      <img
        class="main-content-mask-light"
        src="../../../assets/images/masklight.png"
        alt=""
        ondragstart="return false;"
      />
      <!-- 峰会概览 todo -->
      <div id="summit-overview" class="main-content-wrapper">
        <div class="overview-banner-submit">
          <div class="component">
            <!--         summit  -->
            <div class="component-title">
              <div class="title">Overview</div>
              <div class="component-bor"></div>
            </div>
            <!--        <div class="title-more">查看更多<img src="../../../assets/images/more.png" /></div>-->
          </div>
          <div class="mar-bot"></div>
          <div class="overview">
            <div class="overview-1">
              <div class="f-t">
                <div class="f-s">
                  H3C's Navigate Summit 2023 will take place in Hangzhou on June 9<sup>th</sup>.
                  Under the theme of "Dedication For A Smarter Future", it will bring together
                  thousands of industry heavyweights, authoritative scholars, technical experts,
                  business executives, media, industry analysts and ecological partners.
                </div>
                <div class="f-s">
                  These participants will explore the booming opportunities created by new policies,
                  new technologies and new economic structures created by the digital economy. They
                  will also discuss challenges and coping strategies for the ICT industry in the
                  AIGC era, and share innovative breakthroughs and digital transformation success
                  stories across a variety of industries. Together, we will see, share and discuss
                  how we progress towards a brighter, digitalization-driven future.
                </div>
                <!--                <div class="f-s">-->
                <!--                  The event comprises 1 general conference, 2 digital summits, 20+ thematic forums,-->
                <!--                  100+ keynote speeches and immersive online and offline exhibition centers.-->
                <!--                  However, it is ultimately designed around a key objective – to promote progress-->
                <!--                  towards a brighter, digitalization-driven future.-->
                <!--                </div>-->
                <!--                <div class="f-s">We look forward to your participation!</div>-->
              </div>
            </div>
            <a-row class="overview-2">
              <a-col :span="5">
                <div class="overview-col2">
                  <div>
                    <span class="gradient-text pc-textColor zhonghei">1{{ `${' '}` }} </span>
                    <span class="content-color">General Conference </span>
                  </div>
                  <div class="content-color">Capturing the key trends of the times</div>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="overview-col2">
                  <div>
                    <span class="gradient-text pc-textColor zhonghei">2{{ `${' '}` }}</span>
                    <span class="content-color">Digital Summits</span>
                  </div>
                  <div class="content-color">
                    Accelerating government and enterprise development
                  </div>
                </div>
              </a-col>

              <a-col :span="7">
                <div class="overview-col2 col-3">
                  <div>
                    <span class="gradient-text pc-textColor zhonghei">10+{{ `${' '}` }}</span>
                    <span class="content-color">New Product Releases </span>
                  </div>
                  <div class="content-color">Analysing the latest hot tech</div>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="overview-col2">
                  <div>
                    <span class="gradient-text pc-textColor zhonghei">100+{{ `${' '}` }}</span>
                    <span class="content-color">Keynote Speeches</span>
                  </div>
                  <div class="content-color">Empowering digital transformation</div>
                </div>
              </a-col>

              <!--      <a-col>-->
              <div class="overview-bg-img">
                <img src="../../../assets/images/overview.png" ondragstart="return false;" />
              </div>
              <!--      </a-col>-->
            </a-row>
          </div>
        </div>
      </div>

      <!--  峰会日程  -->
      <div id="summit-agenda" class="main-content-wrapper schedule-bac">
        <div class="overview-schedule">
          <div class="component">
            <div class="component-title">
              <div class="title">Agenda</div>
              <div class="component-bor"></div>
            </div>
            <div class="title-more" @click="hanleGotoSpeaker('pc-agenda')">
              More<img ondragstart="return false;" src="../../../assets/images/more.png" />
            </div>
          </div>

          <!--       tab  -->
          <div class="schedule-title">
            <div class="h3c-tab">
              <div
                v-for="(item, index) in activeKey"
                :key="index"
                @click="itemSelected(item)"
                class="iss-itemSelected"
                :class="isSelected.id === item.id ? 'nav-active' : ''"
              >
                <!--       点击增加字体样式     -->
                <div :class="{ data1: item.id === 1, data: item.id === 0 }">
                  <!--                  <div class="data-title" :class="isSelected == item.id ? 'pc-textColor' : ''">-->
                  <!--                    {{ item.name }}-->
                  <!--                  </div>-->
                  <div
                    class="riqi data-title"
                    :class="isSelected.id === item.id ? 'pc-textColor' : ''"
                    v-html="item.data"
                  ></div>
                </div>
                <!--                <div class="data-border"></div>-->
              </div>
            </div>

            <!--     todo 日程的内容需要后台发布后再替换值, 循环展示list    -->
            <div class="mar-bot"></div>
            <div
              class="schedule"
              v-for="item in activeKey.find((i) => isSelected.id === i.id)?.scheduleList"
              :key="item.id"
            >
              <div class="schedule-left">
                <div class="schedule-left-content">
                  <div class="schedule-time">
                    <div class="schedule-all">
                      <img ondragstart="return false;" :src="item.icon" class="show-hover" />
                      {{ item.all }}
                    </div>
                    <!--          todo 交互 监测鼠标移入峰会日程内容，图标和预约按钮变成hover颜色    -->
                    <div class="schedule-riqi">
                      <img ondragstart="return false;" src="../../../assets/images/time.png" />{{
                        item.time
                      }}
                    </div>
                  </div>
                  <div class="schedule-content">
                    <div class="name">{{ item.name }}</div>
                    <div class="company" v-for="itemTwo in item.content.split('、')" :key="itemTwo">
                      <div>{{ itemTwo }}</div>
                    </div>
                  </div>
                  <div class="schedule-but fs-24" @click="goToLive('5', '全体大会')">
                    Learn More
                    <!--                <a-button class="schedule-but">预约</a-button>-->
                  </div>
                </div>
              </div>

              <!--           右侧banner  -->
              <div class="schedule-right">
                <img ondragstart="return false;" :src="item.banner" />
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="schedule-img">-->
        <!--          <img src="" style="width: 100%; height: 600px" />-->
        <!--        </div>-->
      </div>

      <!--  特邀嘉宾  -->
      <div id="summit-guests" class="main-content-wrapper">
        <img
          class="main-content-mask-rightOne"
          src="../../../assets/images/rightOne.png"
          alt=""
          ondragstart="return false;"
        />
        <!--        <div class="guestTips">-->
        <!--          More high-profile guest speakers are expected to join the conference. Stay tuned for-->
        <!--          updates to the speaker list!-->
        <!--        </div>-->
        <div class="guests-banner">
          <div class="component">
            <div class="component-title">
              <div class="title">Guest Speakers</div>
              <div class="component-bor"></div>
            </div>
            <div class="title-more-guests-invited" @click="hanleGotoSpeaker('pc-speaker')">
              More<img ondragstart="return false;" src="../../../assets/images/more.png" />
            </div>
          </div>
          <!--       峰会嘉宾图片banner切换  -->

          <swiper :slidesPerView="1" :spaceBetween="10" :modules="[]" class="swiperArticle">
            <swiper-slide v-for="item in [1]" :key="item" style="cursor: default; height: auto">
              <div class="h3c-swiper-slide-wrapper">
                <div class="banner-right1" v-for="item in invitedGuests" :key="item">
                  <div class="inside-di">
                    <img ondragstart="return false;" :src="item.banner" class="img-background" />
                  </div>
                  <!--                  <div class="inside">-->
                  <!--                    <img-->
                  <!--                      ondragstart="return false;"-->
                  <!--                      src=""-->
                  <!--                      style="width: 255px; height: 266px"-->
                  <!--                    />-->
                  <!--                  </div>-->
                  <div class="banner-content-invited">
                    <div class="name">{{ item.name }}</div>
                    <!--                    <div class="company">{{ item.content }}</div>-->
                    <div class="company" v-for="itemTwo in item.content.split('*')" :key="itemTwo">
                      <div>{{ itemTwo }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <!--            <div>-->
            <!--              <div-->
            <!--                class="h3c-swiper-slide-prev"-->
            <!--                @click="-->
            <!--                  () => {-->
            <!--                    handleClickNav('prev')-->
            <!--                  }-->
            <!--                "-->
            <!--              ></div>-->
            <!--              <div-->
            <!--                class="h3c-swiper-slide-next"-->
            <!--                @click="-->
            <!--                  () => {-->
            <!--                    handleClickNav('next')-->
            <!--                  }-->
            <!--                "-->
            <!--              ></div>-->
            <!--            </div>-->
          </swiper>
        </div>
      </div>
      <!--   演讲嘉宾   -->
      <div class="main-content-wrapper speakers-top">
        <img
          class="main-content-mask-rightOne"
          src="../../../assets/images/rightOne.png"
          alt=""
          ondragstart="return false;"
        />
        <!--        <div class="speakers-tips">-->
        <!--          More high-profile guest speakers are expected to join the conference. Stay tuned for-->
        <!--          updates to the speaker list!-->
        <!--        </div>-->
        <div class="guests-banner">
          <div class="component">
            <div class="component-title">
              <div class="title">Speakers</div>
              <div class="component-bor"></div>
            </div>
            <div class="title-more-guests" @click="hanleGotoSpeaker('pc-speaker')">
              More<img ondragstart="return false;" src="../../../assets/images/more.png" />
            </div>
          </div>
          <!--       峰会嘉宾图片banner切换  -->

          <swiper :slidesPerView="1" :spaceBetween="10" :modules="[]" class="swiperArticle">
            <swiper-slide v-for="item in [1]" :key="item" style="cursor: default; height: auto">
              <div class="h3c-swiper-slide-wrapper">
                <div class="banner-right1" v-for="item in speakersList" :key="item">
                  <div class="inside-di">
                    <img ondragstart="return false;" :src="item.banner" class="img-background" />
                  </div>
                  <!--                  <div class="inside">-->
                  <!--                    <img-->
                  <!--                      ondragstart="return false;"-->
                  <!--                      src=""-->
                  <!--                      style="width: 255px; height: 266px"-->
                  <!--                    />-->
                  <!--                  </div>-->
                  <div class="banner-content">
                    <div class="name">{{ item.name }}</div>
                    <!--                    <div class="company">{{ item.content }}</div>-->
                    <div class="company" v-for="itemTwo in item.content.split('*')" :key="itemTwo">
                      <div>{{ itemTwo }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <!--            <div>-->
            <!--              <div-->
            <!--                class="h3c-swiper-slide-prev"-->
            <!--                @click="-->
            <!--                  () => {-->
            <!--                    handleClickNav('prev')-->
            <!--                  }-->
            <!--                "-->
            <!--              ></div>-->
            <!--              <div-->
            <!--                class="h3c-swiper-slide-next"-->
            <!--                @click="-->
            <!--                  () => {-->
            <!--                    handleClickNav('next')-->
            <!--                  }-->
            <!--                "-->
            <!--              ></div>-->
            <!--            </div>-->
          </swiper>
        </div>
      </div>

      <!--   商城 todo 需要更改内容  -->
      <!--      <div id="attending-guidelines" class="shopping">-->
      <!--        <div class="main-content-wrapper">-->
      <!--          &lt;!&ndash;     main-content-mask-rightOne   &ndash;&gt;-->
      <!--          <div class="overview-shopping">-->
      <!--            <div class="mar-bot"></div>-->
      <!--            <div class="shopping-content">-->
      <!--              <div class="shopping-img">-->
      <!--                <img ondragstart="return false;" src="../../../assets/images/shopping-list.png" />-->
      <!--              </div>-->
      <!--              <div class="shopping-main">-->
      <!--                <div class="shoppingOne">创新、颠覆企业级服务理念</div>-->
      <!--                <div class="shoppingTwo">打造原厂、合作伙伴、客户共赢新模式！</div>-->
      <!--                <div class="checkOut" @click="checkOutShopping">立即查看</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--  参会指南  -->
      <div id="attending-guidelines" class="meetingContent">
        <img
          class="meeting-bac-img"
          src="../../../assets/images/meeting-bac.png"
          alt=""
          ondragstart="return false;"
        />
        <div class="main-content-wrapper">
          <!--     main-content-mask-rightOne   -->
          <div class="overview-meeting">
            <div class="component">
              <div class="component-title">
                <div class="title">Participation Guide</div>
                <div class="component-bor"></div>
              </div>
              <!--        <div class="title-more">查看更多<img src="../../../assets/images/more.png" /></div>-->
            </div>
            <div class="mar-bot"></div>
            <div class="meeting">
              <div class="meeting-address">
                <!-- <div class="meeting-bac">
                  <img src="../../../assets/images/address.png" />
                </div> -->
                <div class="meeting-content">
                  <div class="downloadStyle">
                    <div class="meeting-addressText">Onsite Participation</div>
                    <div class="meeting-left" @click="handleDownload">
                      <img src="../../../assets/images/downloadIcon.png" class="downloadIcon" />
                      <div class="download fs-20">Download</div>
                    </div>
                  </div>
                  <div class="meeting-addressData">
                    <img
                      ondragstart="return false;"
                      src="../../../assets/images/address-icon.png"
                      class="meeting-icon-time"
                    />
                    <div>June 9<sup>th</sup>, 2023</div>
                  </div>
                  <div class="mt-16 mb-16 meeting-addressView">
                    <!-- <img
                      ondragstart="return false;"
                      src="../../../assets/images/bolan.png"
                      class="meeting-icon-time"
                    /> -->
                    <div class="meeting-address-text fs-14">Hangzhou International Expo Center</div>
                  </div>
                  <div class="meeting-addressView">
                    <img
                      ondragstart="return false;"
                      src="../../../assets/images/map-icon.png"
                      class="meeting-icon"
                    />
                    <div class="meeting-address-text">
                      353 Benjing Ave, Qianjiang Century City, Xiaoshan District, Hangzhou
                    </div>
                  </div>
                  <div class="meeting-address-text meeting-address-invite fs-16 mt-16">
                    <span class="fuhao fuhao-invite">*</span>
                    Invited guests please follow the on-site organizers' attendance instructions to
                    attend the event.
                  </div>
                </div>
                <div class="download-btn" @click="downloadPdf">download</div>
              </div>

              <!--          todo 标签    -->
              <!--            </div>-->
              <!--          todo bac   ../../../assets/images/meeting-bac.png" -->
              <div class="meeting-address meeting-address-right">
                <!-- <div class="bac-img">
                  <img ondragstart="return false;" src="" />
                </div> -->

                <div class="meeting-content">
                  <div class="meeting-addressText">Online Participation</div>
                  <div class="meeting-addressData">
                    <img
                      ondragstart="return false;"
                      src="../../../assets/images/address-icon.png"
                      class="meeting-icon-time"
                    />
                    <div>June 9<sup>th</sup>, 2023</div>
                  </div>

                  <div class="meeting-addressView canhui-right">
                    <div
                      class="meeting-address-text fs-18 schedule-but"
                      v-if="getTime()"
                      @click="goToLive('5', '全体大会')"
                    >
                      Watch Live
                    </div>
                    <div
                      class="meeting-address-text fs-18 schedule-but"
                      v-else-if="handleEndTime()"
                      @click="goToLive('5', '全体大会')"
                    >
                      Playback
                    </div>
                    <!--              @click="handleClickReservation"       -->
                    <div
                      class="reservation-btn fs-18 schedule-but"
                      v-else-if="scheduleDisable"
                      @click="goToLive('5', '全体大会')"
                    >
                      <span>Register now</span>
                    </div>
                    <div
                      class="reservation-btn reservation-Done"
                      @click="goToLive('5', '全体大会')"
                      v-else
                    >
                      <span>Reserved</span>
                    </div>
                  </div>
                  <div class="meeting-address-text fs-14 mt-16 canhui-right">
                    <span class="fuhao">*</span>
                    You can watch the live stream and engage in <br />
                    interactive activities online.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  历届峰会 todo -->
      <div id="previous-summits" class="main-content-wrapper">
        <div class="overview-meeting meetingPrevious">
          <div class="component">
            <div class="component-title">
              <div class="title">Previous Summits</div>
              <div class="component-bor"></div>
            </div>
            <!--        <div class="title-more">查看更多<img src="../../../assets/images/more.png" /></div>-->
          </div>

          <div class="mar-bot"></div>

          <!--          <div>-->
          <!--            <img-->
          <!--              class="previous-img"-->
          <!--              ondragstart="return false;"-->
          <!--              src="../../../assets/images/summits.png"-->
          <!--              @click="handleLeft1"-->
          <!--            />-->
          <!--          </div>-->
          <div class="meeting-img-box">
            <div class="meeting-img-wrapper" id="meeting-img-wrapper">
              <!--            2021   -->
              <img
                class="previous-img"
                ondragstart="return false;"
                src="../../../assets/images/left1-EN.jpg"
                @click="handleLeft1"
              />
              <!--          2020    -->
              <img
                class="previous-img"
                ondragstart="return false;"
                src="../../../assets/images/left2-EN.jpg"
                @click="handleLeft2"
              />
              <!--           2019   -->
              <img
                class="previous-img"
                ondragstart="return false;"
                src="../../../assets/images/left3-EN.jpg"
                @click="handleLeft3"
              />
            </div>
          </div>
          <!--          <a-row>-->
          <!--            <a-col :span="6">-->
          <!--              <img-->
          <!--                class="previous-img"-->
          <!--                ondragstart="return false;"-->
          <!--                src="../../../assets/images/left1.png"-->
          <!--                @click="handleLeft1"-->
          <!--              />-->
          <!--            </a-col>-->
          <!--            <a-col :span="6"-->
          <!--              ><img-->
          <!--                class="previous-img"-->
          <!--                ondragstart="return false;"-->
          <!--                src="../../../assets/images/left2.png"-->
          <!--                @click="handleLeft2"-->
          <!--            /></a-col>-->
          <!--            <a-col :span="6"-->
          <!--              ><img-->
          <!--                class="previous-img"-->
          <!--                ondragstart="return false;"-->
          <!--                src="../../../assets/images/left3.png"-->
          <!--                @click="handleLeft3"-->
          <!--            /></a-col>-->
          <!--            <a-col :span="6"-->
          <!--              ><img-->
          <!--                class="previous-img"-->
          <!--                ondragstart="return false;"-->
          <!--                src="../../../assets/images/left4.png"-->
          <!--                @click="handleLeft4"-->
          <!--            /></a-col>-->
          <!--          </a-row>-->
        </div>
      </div>

      <!--  支持伙伴/媒体  -->
      <div class="main-content-wrapper">
        <div class="partner-banner partner-bor">
          <div class="component">
            <div class="component-title">
              <div class="title">Partner</div>
              <div class="component-bor"></div>
            </div>
            <!--            <div class="title-more-partner">-->
            <!--              查看更多<img ondragstart="return false;" src="../../../assets/images/more.png" />-->
            <!--            </div>-->
          </div>
          <!--     伙伴媒体切图   -->
          <div class="mar-bot"></div>
          <div class="partner">
            <div class="partner-circulate" v-for="item in partnerHomeList" :key="item.id">
              <div class="partner-img" @click="handlePartnerUrl(item)">
                <img ondragstart="return false;" :src="item.partnerHomeLogo" class="partner-size" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modalStyle" ref="mymodal">
    <a-modal
      :width="500"
      :visible="successVisible"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      :footer="null"
      centered
      class="chang-modal"
      :getContainer="() => mymodal"
    >
      <div class="chang-modal">
        <div class="attention">You have scheduled the meeting, please take a look around~</div>
        <div html-type="submit" class="succeed-but" @click="handleConfirm">
          OK{{ `(${count}s)` }}
        </div>
        <div html-type="cancel" @click="handleCancelConfirm" class="cancel">
          <img src="../../../assets/images/modal-cancel.png" style="width: 40px; height: 40px" />
        </div>
      </div>
    </a-modal>
  </div>
  <!--  悬浮按钮-->
  <!--  <float-btn></float-btn>-->
  <!--  鉴权二英文版 -->
  <authentication-one
    v-model:visible="isModalVisible"
    @update:visible="handleModalVisibleChange"
    :event-info="eventInfo"
  />

  <!--  登录 -->
  <authentication-two
    v-model:visible="visibleTwo"
    @update:visible="handleVisibleTwoChange"
    :event-info="eventInfo"
  />
</template>

<script>
import { Row, Col, Modal, message } from 'ant-design-vue'
// import floatBtn from '@/views/pc/home/floatBtn'
import { saveAs } from 'file-saver'
import { reactive, toRefs, ref, getCurrentInstance, onMounted, watch, onBeforeMount } from 'vue'
import authenticationOne from '../components/authenticationOne'
import authenticationTwo from '../components/authenticationTwo'
import { useMeta } from 'vue-meta'
import Cookies from 'js-cookie'
import tdk from './tdk'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { schedule, aesDecryptHex, getMakeStatus, partnerHome } from '@/service/api/pc'
import { getEventDetail } from '@/service/api/navLive'

import { session } from '@/utils/storage'
import mudu from '@/utils/mudu'
export default {
  components: {
    // floatBtn,
    ARow: Row,
    ACol: Col,
    AModal: Modal,
    authenticationOne,
    authenticationTwo
  },
  setup() {
    useMeta(tdk)
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const mymodal = ref()
    const h3cUser = store.getters['userStore/getUser']
    const state = reactive({
      timer: null,
      getCookies: true,
      successVisible: false,
      scheduleDisable: true,
      eventInfo: {},
      partnerHomeList: [],
      activeKey: [
        {
          id: 0,
          name: 'DAY1',
          data: 'June 9<sup class="pc-textColor">th</sup>',
          scheduleList: [
            {
              all: 'General Conference',
              time: '9:00 – 11:30 (UTC/GMT+08:00)',
              content:
                "In addition to gaining an up-close look at H3C's newest technology strategies and products, thousands of guests will hear discussion of  the latest technologies and digital transformation trends, contribute to the industry. Perhaps more importantly, they'll also learn how these developments are contributing to industrial efficiency and paving the way to a successful and sustainable future.",
              banner: require('../../../assets/images/schedule9.png'),
              id: 0,
              icon: require('../../../assets/images/all.png')
            }
            // {
            //   all: '数智治理峰会',
            //   time: '13:30-15:30',
            //   content:
            //     '由《财经》战略支持，聚焦数智赋能城市治理能力现代化进程，邀请城市数字化转型领军城市管理者、知名经济学家、优秀企业家等共聚共论，探索数字中国背景下的城市发展范式。',
            //   banner: require('../../../assets/images/schedule-ban1.png'),
            //   id: '2',
            //   icon: require('../../../assets/images/scheduleOne.png')
            // },
            // {
            //   all: '企业数智化转型峰会',
            //   time: '13:30-15:30',
            //   content:
            //     '由《财经》战略支持，汇聚专家领袖，以业界前瞻视角，分享企业数字大脑实践成果，为百行百业数字化转型提供支撑参考，助力企业高质量发展。',
            //   banner: require('../../../assets/images/schedule-ban2.png'),
            //   id: '3',
            //   icon: require('../../../assets/images/scheduleOne.png')
            // }
          ]
        }
        // {
        //   id: 1,
        //   name: 'DAY2-5',
        //   data: '6月10日-13日'
        // }
      ],
      isSelected: {
        id: 0,
        name: 'DAY1',
        data: 'June 9th'
      },
      count: 3,
      scheduleList: [
        {
          all: 'General Conference',
          time: '9:00 – 11:30 (UTC/GMT+08:00)',
          content:
            ' In the face of changes and new opportunities, H3C will release new technology strategies and products, invite thousands of guests to discuss the latest technologies and trends during digital transformation, contribute to the industry, and bring wisdom to the times.',
          banner: require('../../../assets/images/schedule-banner-EN.png'),
          id: 0,
          icon: require('../../../assets/images/all.png')
        }
        // {
        //   all: '数智治理峰会',
        //   time: '13:30-15:30',
        //   content:
        //     '由《财经》战略支持，聚焦数智赋能城市治理能力现代化进程，邀请城市数字化转型领军城市管理者、知名经济学家、优秀企业家等共聚共论，探索数字中国背景下的城市发展范式。',
        //   banner: require('../../../assets/images/schedule-ban1.png'),
        //   id: '2',
        //   icon: require('../../../assets/images/scheduleOne.png')
        // },
        // {
        //   all: '企业数智化转型峰会',
        //   time: '13:30-15:30',
        //   content:
        //     '由《财经》战略支持，汇聚专家领袖，以业界前瞻视角，分享企业数字大脑实践成果，为百行百业数字化转型提供支撑参考，助力企业高质量发展。',
        //   banner: require('../../../assets/images/schedule-ban2.png'),
        //   id: '3',
        //   icon: require('../../../assets/images/scheduleOne.png')
        // }
      ],
      // 演讲嘉宾
      speakersList: [
        {
          name: 'Brighten LI',
          content: 'Chairman of Tsinghua Unigroup',
          banner: require('../../../assets/images/libin.png'),
          id: '1'
        },
        {
          name: 'Tony YU',
          content: 'Chairman of the Board of Unisplendour*CEO & President of H3C',
          banner: require('../../../assets/images/guest1.png'),
          id: '1'
        },
        {
          name: 'Steven YOE',
          content: 'Co-president of H3C* CTO & Chairman of Technical Committees',
          banner: require('../../../assets/images/guest2.png'),
          id: '1'
        },
        {
          name: 'Peng ZHANG',
          content: 'Senior Vice President of H3C*CDO & Director of the Digital China Institute',
          banner: require('../../../assets/images/zhangpeng.png'),
          id: '1'
        }
      ],
      //  特邀嘉宾
      invitedGuests: [
        {
          name: 'Weiying ZHANG',
          content:
            'Boya Chair Professor of National School of Development,Peking University* Director of Peking University Center for Market and Network Economy',
          banner: require('../../../assets/images/zhangweiyin.png'),
          id: '1'
        },
        {
          name: 'Dou SHEN',
          content: 'Executive Vice President of Baidu*President of Baidu AI Cloud Group',
          banner: require('../../../assets/images/Shen.png'),
          id: '1'
        },

        {
          name: 'Alan WANG',
          content: 'VP of SMG, PRC Country Manager of Intel',
          banner: require('../../../assets/images/WANG.png'),
          id: '1'
        }
      ]
    })
    const isModalVisible = ref(false)
    const visibleTwo = ref(false)
    const handleModalVisibleChange = (visible) => {
      isModalVisible.value = visible
    }
    const handleVisibleTwoChange = (visible) => {
      visibleTwo.value = visible
    }
    partnerHome().then((res) => {
      state.partnerHomeList = res
    })
    // // todo 获取store数据
    watch(
      () => store.state.userStore.user.id,
      (value) => {
        console.log('watch value', value)
        if (value) {
          getMakeStatus({
            phone: h3cUser.phone,
            scheduleId: '5',
            userId: h3cUser.id
          }).then((res) => {
            console.log('res', res)
            state.scheduleDisable = res.data
          })
        } else {
          state.scheduleDisable = true
        }
      },
      { deep: true }
    )

    //  todo   1、每次进入页面先去拿cookies,同一浏览器有cookies就放行，无感调用接口验证，让用户处理登录状态
    //     2、进入页面如果没有cookies,登录状态不用变，等用户触发行为后再去走功能逻辑

    // let userDate = Cookies.get('h3c_user')
    // if (!userDate) {
    //   return
    // }
    // store.commit('userStore/changeUser', userDate)
    // let user = JSON.parse(store.getters['userStore/getUser'])
    // if (user) {
    //   loginChina({
    //     ...user
    //   }).then(() => {
    //     state.getCookies = true
    //     // // todo 存储数据到store
    //     store.commit('userStore/changeUser', user)
    //   })
    // }
    // const route = useRoute();
    // const getRootFontSize = () => {
    //   const designWidth = 1920 // 设计稿宽度为 1920 像素
    //   const screenWidth = window.screen.width
    //   return (screenWidth / designWidth) * 16
    // }
    // const pxToRem = (px) => {
    //   return (px / getRootFontSize()).toFixed(5) + 'rem'
    // }
    // const metaManager = createMetaManager(false, {
    //   meta: { tag: 'meta', nameless: true }
    // })
    //const { meta } =createMetaManager
    const handleClickNav = (type) => {
      switch (type) {
        case 'prev':
          console.log(type)
          break
        case 'next':
          console.log(type)
          break
        default:
          break
      }
    }
    // 3秒弹窗
    const countdown = () => {
      // todo 弹窗 您已预约会议，再逛逛吧
      state.count = 3
      let TIME_COUNT = 3
      if (!state.timer) {
        state.timer = setInterval(() => {
          state.successVisible = true
          if (state.count > 0 && state.count <= TIME_COUNT) {
            state.count--
          } else {
            clearInterval(state.timer)
            state.timer = null
            state.successVisible = false
          }
        }, 1000)
      }
    }

    const register = (h3cUser) => {
      let parmas = {
        phone: h3cUser.phone,
        scheduleId: '5',
        userId: h3cUser.id
      }
      //  预约接口
      schedule(parmas).then((res) => {
        window._gsq.push([
          'track',
          'Schedule_Appointment',
          {
            page_name: '首页',
            phone: h3cUser.phone,
            button_name: '全体大会 预约',
            login_status: '预约提交'
          }
        ])
        if (res.code === 20007) {
          return message.success('Failed. Please try again later')
        } else if (res.code === 20008) {
          return message.success('Failed. Please try again later')
        } else if (res.code === 20003) {
          return message.success('Failed. Please try again later')
        } else if (res.code === 20006) {
          // todo 弹窗 您已预约会议，再逛逛吧
          countdown()
        } else if (res.code === 0) {
          // authOne.value.successVisible = true
          message.success('Reservation successful')
        }
      })
    }
    // 解密接口
    const decrypt = async (encryptDdata) => {
      console.log('encryptDdata 解密', encryptDdata)
      const res = await aesDecryptHex({ json: encryptDdata })
      let data = JSON.parse(res.data)
      console.log('data解密', data)
      store.commit('userStore/changeUser', data)
      return data
    }

    const handleClickReservation = async () => {
      console.log('登录注册后点击预约直播')
      window._gsq.push([
        'track',
        'Schedule_Appointment',
        { page_name: '首页', button_name: '全体大会 预约' }
      ])
      //   todo 预约直播需要做逻辑处理 cookies有用户数据，则点击直接调取接口，不用弹窗，否则弹窗填写内容
      let userDate = Cookies.get('h3c_user')
      console.log('userDate', userDate)
      // 登录数据存储到cookies
      // todo 存储数据到store
      if (!userDate) {
        state.eventInfo = { eventid: 228, scheduleId: '5' }
        handleModalVisibleChange(true)
      } else {
        const h3cUser = await decrypt(userDate)
        console.log('h3cUser index', h3cUser)
        register(h3cUser)
      }
    }

    let userDate = Cookies.get('h3c_user')
    userDate && decrypt(userDate)

    const { proxy } = getCurrentInstance()
    proxy.$bus.on('changeAuthenticationTwo', handleVisibleTwoChange)
    proxy.$bus.on('openAuthenticationOne', handleClickReservation)
    proxy.$bus.on('countdown', countdown)
    const getLiveStatus = async ({ id, source = '0' }) => {
      const eventid = Number(id)
      //eventdetail 4、会议信息明细
      const result = await getEventDetail({ eventid, source })
      return result.data
    }
    onMounted(() => {
      if (session.get('is_form_cn_register')) {
        session.remove('is_form_cn_register')
        handleVisibleTwoChange(true)
      }
      if (session.get('scrollId')) {
        const elem = document.getElementById(session.get('scrollId'))
        if (elem) {
          elem.scrollIntoView({
            behavior: 'smooth',
            // block: 'center',
            inline: 'nearest'
          })
        }
        session.remove('scrollId')
      }
      getLiveStatus({ id: process.env.VUE_APP_YUNPING_ID }).then((res) => {
        console.log('res55', res)
        const muduId = 's_' + res?.gsownerid
        mudu.init(
          {
            id: muduId,
            playerOptions: [{ containerId: 'mudu-video' }],
            noticeId: '',
            user: {}
          },
          proxy
        )
      })
    })
    onBeforeMount(() => {
      if (store.state.userStore.user.id) {
        getMakeStatus({
          phone: h3cUser.phone,
          scheduleId: '5',
          userId: h3cUser.id
        }).then((res) => {
          console.log('res', res)
          state.scheduleDisable = res.data
        })
      } else {
        state.scheduleDisable = true
      }
    })
    // 开始时间处理 观看直播场景
    const getTime = () => {
      // '2023-05-31T15:00:00' '2023-05-31T17:30:00'
      // '2023-06-09T09:00:00' '2023-06-09T11:30:00'
      // '2023-05-31T11:00:00'
      let startTime = '2023-06-09T09:00:00'
      let endTime = '2023-06-09T11:30:00'
      // 获取开始时间戳
      let starttamp = Date.parse(startTime)
      // 获取结束时间戳
      let endtamp = Date.parse(endTime)
      // 获取当前时间戳 或者 new Date().getTime()
      let current_timestamp = Date.now()
      // 当前时间大于开始时间并且当前时间小于结束时间，则表示直播已经开始
      if (current_timestamp >= starttamp && current_timestamp <= endtamp) {
        // todo 打开直播间 需要拿到直播间id跳转直播间
        // window.open('https://www.h3c.com/cn/', '_blank')
        return true
      } else {
        return false
      }
    }
    // 结束时间处理， 观看回放场景
    const handleEndTime = () => {
      // '2023-05-31T17:30:00' '2023-06-09T11:30:00' '2023-05-31T12:30:00'
      let endTime = '2023-06-09T11:30:00'
      // 结束时间的时间戳
      let endtamp = Date.parse(endTime)
      // 获取当前时间戳 或者 new Date().getTime()
      let current_timestamp = Date.now()
      // 当前时间大于等于结束时间，则表示直播已经结束
      if (current_timestamp > endtamp) {
        return true
      } else {
        return false
      }
    }
    // 特定时间替换首页banner,出现直播
    const getBannerTime = () => {
      // '2023-05-31T15:00:00' '2023-05-31T17:30:00'
      // '2023-06-09T09:00:00' '2023-06-09T11:30:00'
      // '2023-05-31T11:00:00'
      let startTime = '2023-06-08T22:00:00'
      // let endTime = '2023-06-14T22:00:00'
      // 获取开始时间戳
      let starttamp = Date.parse(startTime)
      // 获取结束时间戳
      // let endtamp = Date.parse(endTime)
      // 获取当前时间戳 或者 new Date().getTime()
      let current_timestamp = Date.now()
      // 当前时间大于开始时间并且当前时间小于结束时间，
      if (current_timestamp >= starttamp) {
        return true
      } else {
        return false
      }
    }
    return {
      getBannerTime,
      getTime,
      handleEndTime,
      handleClickNav,
      ...toRefs(state),
      isModalVisible,
      // visibleTwo,
      mymodal,
      handleDownload: () => {
        let file = 'https://navigatesummit.h3c.com/2023/NAVIGATE%202023%20Participation%20Guide.pdf'
        saveAs(file, 'NAVIGATE 2023 Participation Guide.PDF')
      },
      goToLive() {
        //   todo 观看直播+观看回放 跳转当前数据的直播间
        window.open(
          process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_PUBLIC_PATCH +
            `session/` +
            process.env.VUE_APP_QUANTI_ID,
          '_blank'
        )
      },
      hanleGotoSpeaker: (routeName) => {
        router.push({ name: routeName, query: route.query })
      },
      itemSelected: (item) => {
        state.isSelected = item
      },
      handleCancelConfirm() {
        clearInterval(state.timer)
        state.timer = null
        state.successVisible = false
      },
      handleLeft1: () => {
        window._gsq.push([
          'track',
          'All_previous',
          { page_name: '首页', button_name: '历届峰会2021' }
        ])
        window.open('https://navigate.h3c.com/pages/en/pc/index.html', '_blank')
      },
      handleLeft2: () => {
        window.open('https://navigate.h3c.com/2020/en/', '_blank')
      },
      handleLeft3: () => {
        window.open('https://navigate.h3c.com/2019/en/', '_blank')
      },
      // handleLeft4: () => {
      //   window.open('https://navigate.h3c.com/2018/index.html?y=2018', '_blank')
      // },

      // checkOutShopping: () => {
      //   window.open('https://www.h3cmall.com/', '_blank')
      // },
      downloadPdf: () => {
        window.open('https://www.h3cmall.com/', '_blank')
      },
      handleModalVisibleChange,
      handleVisibleTwoChange,
      handleConfirm() {
        // 需要清除定时器
        clearInterval(state.timer)
        state.timer = null
        state.successVisible = false
      },
      handleClickReservation
    }
  }
}
</script>

<style scoped lang="less">
.main {
  color: #ffffff;
  //transform: translateY(-140px);
}
.mainContent {
  /*background: linear-gradient(to right, #070a11 100%, #0f1a4d 100%);*/
  /*width: 1920px;*/
  /*max-height: 1920px;*/
  /*overflow: auto;*/
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .main-content-mask-light {
    user-select: none;
    user-drag: none;

    position: absolute;
    width: 1015px;
    left: 0;
    top: 0;
  }
  .main-content-mask-rightOne {
    user-select: none;
    user-drag: none;
    width: 1075px;
    height: 1373px;
    position: absolute;
    right: 0;
    top: -600px;
  }
  .guestTips {
    user-select: none;
    user-drag: none;
    position: absolute;
    top: 650px;
    right: 345px;
    font-size: 16px;
    //left: 1200px;
  }
  .speakers-tips {
    user-select: none;
    user-drag: none;
    position: absolute;
    top: 750px;
    right: 345px;
    font-size: 16px;
  }
}
.meetingContent {
  position: relative;
  .meeting-bac-img {
    user-select: none;
    user-drag: none;

    position: absolute;
    width: 350px;
    left: -130px;
    top: 260px;
  }
}
.main-content-wrapper {
  position: relative;
  width: 100%;
}
/* 内容区的样式 */
.overview {
  width: 1200px; /* no-pxtorem */
  position: relative;
  padding: 50px;
  margin: 0 auto;
  //background-image: url('../../../assets/images/overview.png');
  /*border-style: solid;*/
  /* 布局后最底下的底纹再打开 */
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
}
.overview-schedule {
  width: 1200px; /* no-pxtorem */
  position: relative;
  margin: 0 auto;
  margin-top: 100px;
  z-index: 9;
  /*border-style: solid;*/
  /* 布局后最底下的底纹再打开 */
  /* background: linear-gradient(to right, #ffffff 10%, #ffffff 0%); */

  /* 这个background不对，后续需要换成白色  */
  //background: linear-gradient(to right, #070a11 100%, #0f1a4d 100%);
}
.schedule-title {
  padding: 50px 0;
}

.h3c-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid #485166;
}
.gradient-text {
  font-weight: 500;
  font-size: 32px;
}
.content-color {
  font-size: 16px;
  color: #ffffff;
}
.f-s {
  width: 1100px;
  font-size: 18px;
  //text-indent: 2em;
  color: #ffffff;
  line-height: 30px;
}
.font-s {
  font-size: 22px;
  font-weight: 500;
}
.overview-1 {
  /*width: 1100px;*/

  color: #ffffff;
  letter-spacing: 1px;
}
.overview-2 {
  width: 1030px;
  margin-left: 10px;
}
.overview-child {
  position: absolute;
  top: 213px;
  left: 1119px;
}
.overview-bg-img {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateX(50%);
  width: 160px;
  height: 160px;
  img {
    width: 100%;
    height: 100%;
  }
}
.f-t {
  padding-bottom: 50px;
}
.navigate-img-1 {
  width: 100%;
  height: auto;
}

.navigate-background {
  position: relative;
  .radio {
    position: absolute;
    height: 544px;
    width: 831px;
    background-image: url('../../../assets/images/radio-img.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    top: 208px;
    right: 201px;
    .muduRadioKV {
      position: absolute;
      width: 815px;
      height: 458px;
      background-image: url('../../../assets/images/live/liveKV.png');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center center; /* 将静态图像居中 */
      top: 52px;
      left: 8px;
    }
    .muduRadio {
      width: 815px;
      height: 458px;
      position: absolute;
      top: 52px;
      left: 8px;

      .mudu-video {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }
      #mudu-video {
        z-index: 2;
      }
    }
  }

  .reservation {
    position: absolute;
    width: 1200px; /* no-pxtorem */
    height: 100%;
    top: 0;
    right: 50%;
    transform: translateX(50%);
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    &.time-out {
      .reservation-btn {
        left: -170px;
        font-size: 24px;
        width: 160px;
        height: 60px;
      }
    }
    .reservation-btn {
      position: absolute;
      bottom: 120px;
    }
    .reservation-Done {
      position: absolute;
      bottom: 120px;
      z-index: 20;
      user-select: none;
      cursor: pointer;
      //cursor: not-allowed; /* 光标变为无效符号 */
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 70px;
      left: 0;
      font-size: 28px;
      background: linear-gradient(90deg, #0a97c7 0%, #00cccc 66%, #27d990 100%);
      //.scheduleDone {
      //  cursor: not-allowed; /* 光标变为无效符号 */
      //  pointer-events: none; /* 禁止用户触发事件 */
      //}
    }
    .navigate-img {
      width: 640px;
      height: 410px;
    }
    .reservation-btn {
      z-index: 20;
      user-select: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 70px;
      position: absolute;
      left: 0;
      bottom: 141px;
      font-size: 28px;
      background: linear-gradient(90deg, #0a97c7 0%, #00cccc 66%, #27d990 100%);
    }
    //@media (max-width: 1599px) {
    //  /* 在屏幕小于 1600px 时触发的样式 */
    //  .navigate-img {
    //    width: 546px;
    //    height: 350px;
    //    //transform: scale(0.8)
    //    //position: absolute;
    //    //top: 218px;
    //    //left: 0px;
    //  }
    //
    //  .reservation-btn {
    //    width: 182px;
    //    height: 64px;
    //    bottom: 116px;
    //    font-size: 24px;
    //  }
    //}
  }
}
.component-bor {
  width: 80px;
  height: 4px;
  //border-top: solid;
  background: linear-gradient(180deg, #0a97c7 0%, #00cccc 50%, #27d990 100%);
  -webkit-text-fill-color: transparent;
  /*margin-left: 560px;*/

  position: absolute;
  top: 72px;
  transform: translateX(-50%);
  left: 50%;
}

.component {
  color: #ffffff;
  position: relative;
}
.title {
  font-size: 40px;
  text-align: center;
}
.component-title {
  width: 100%;
  //position: relative;
}

.title-more {
  cursor: pointer;
  right: 0;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  img {
    width: 18px;
    height: 6px;
    transform: translateY(-2px);
    margin-left: 10px;
  }
}
.title-more-guests-invited {
  cursor: pointer;
  right: 62px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  z-index: 2;
  img {
    width: 18px;
    height: 6px;
    transform: translate(10px, -2px);
  }
}
.title-more-guests {
  cursor: pointer;
  right: 62px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  img {
    width: 18px;
    height: 6px;
    transform: translate(10px, -2px);
  }
}
.title-more-partner {
  cursor: pointer;
  right: 18px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  img {
    width: 18px;
    height: 6px;
    transform: translate(10px, -2px);
  }
}
.iss-itemSelected {
  position: relative;
  display: inline-block;
  color: #ffffff;
  //padding-top: 53px;
  text-align: center;
  margin-right: 20px;
}

.data {
  user-select: none;
  cursor: pointer;
  width: 100px;
  //padding: 0 437px;
  //position: absolute;
  //top: -25%;
  //left: 520px;
}
.data1 {
  user-select: none;
  cursor: pointer;
  width: 100px;
  //position: absolute;
  //top: -25%;
  //left: 600px;
}
.nav-active {
  .data-title {
    font-weight: 500;
  }
  .data::after {
    content: '';
    position: absolute;
    width: 100px;
    height: 5px;
    left: 0;
    bottom: 0;
    /*background: linear-gradient(180deg, #0a97c7 0%, #00cccc 50%, #27d990 100%);*/
    background: url('../../../assets/images/line.png') center center no-repeat;
    background-size: cover;
  }
  .data1::after {
    content: '';
    position: absolute;
    width: 100px;
    height: 5px;
    left: 0;
    bottom: 0;
    /*background: linear-gradient(180deg, #0a97c7 0%, #00cccc 50%, #27d990 100%);*/
    background: url('../../../assets/images/line.png') center center no-repeat;
    background-size: cover;
  }
}

.data-title {
  font-size: 20px;
  font-weight: 400;
}
.riqi {
  //font-size: 12px;
  margin-bottom: 19px;
}
.data-border {
  width: 1200px; /* no-pxtorem */
  height: 1px;
  background: #485166;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  position: absolute;
  //top: 57px;
  //left: -50px;
  //margin-bottom: 50px;
}
.schedule {
  display: flex;
  justify-content: space-between;
  /*margin-top: 50px;*/
  margin-bottom: 20px;
  background: #042c53;
}
.schedule-left {
  padding: 18px 18px;
  position: relative;
  .schedule-but {
    cursor: pointer;
    //width: 90px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 255, 255, 0.1);
    opacity: 1;
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 15px;
    top: 195px;
    padding: 12px 20px;
    background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
  }
}
.schedule-right {
  img {
    width: 450px;
    height: auto;
  }
}
.schedule-content {
  padding: 20px 0px 0px 0px;
  font-size: 16px;
}
.schedule-time {
  display: flex;
  justify-content: space-between;
}
.schedule-all {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 20px;
    height: 24px;
    margin-right: 10px;
  }
}
.schedule-riqi {
  font-size: 20px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-bottom: 4px;
  }
}
//.schedule-but {
//  cursor: pointer;
//  width: 90px;
//  height: 34px;
//  background: rgba(255, 255, 255, 0.1);
//  opacity: 1;
//  border: 1px solid rgba(255, 255, 255, 0.2);
//  display: flex;
//  justify-content: center;
//  align-items: center;
//  position: absolute;
//  left: 50px;
//}

.schedule-but {
  //width: 90px;
  height: 34px;
  color: #ffffff;
  background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 12px 20px;
}

//.schedule-but:hover {
//  background: linear-gradient(to right, #0a97c7, #00cccc, #27d990);
//  color: #ffffff;
//}
.mar-bot {
  margin-bottom: 50px;
}
.previous-img {
  width: 1200px;
  height: auto;
  cursor: pointer;
}
/* 轮播图样式 */
.overview-banner-submit {
  width: 1300px;
  position: relative;
  padding: 100px 0;
  margin: 0 auto;
}
.overview-banner {
  width: 1200px;
  position: relative;
  padding: 50px 0;
  margin: 0 auto;
}
.guests-banner {
  width: 1300px;
  position: relative;
  //padding: 50px 0;
  padding-top: 100px;
  margin: 0 auto;
}
.speakers-top {
  padding-top: 100px;
}
//.guests-banner /deep/ .swiper {
//  --swiper-navigation-size: 0;
//}

.guests-banner /deep/ .swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: 'next';
  background: linear-gradient(to right, #4dd2ff, #bfffff, #4dff89);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: absolute;
  right: -10px;
  cursor: pointer;
}

.guests-banner /deep/ .swiper-button-prev {
  background: linear-gradient(to right, #4dd2ff, #bfffff, #4dff89);
  content: 'prev';
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: absolute;
  margin-left: -10px;
  font-size: 10px;
}
.h3c-swiper-slide-prev {
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  //background-image: url('../../../assets/images/icon-left.png');
  background-size: 10px 18px;
  //background-repeat: no-repeat;
  left: 0;
  top: 50%;
  background-position: 45% 50%;
}

.swiperArticle {
  padding: 0 22px;
}
.partner-banner {
  width: 1200px; /* no-pxtorem */
  position: relative;
  padding: 50px 0;
  margin: 0 auto 100px;
}

.banner {
  display: flex;
  padding-top: 20px;
}

.ant-carousel :deep(.slick-slide) {
  text-align: center;
  overflow: hidden;
}

.overview-banner :deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  opacity: 0.3;
  z-index: 1;
  border-radius: 15px;
}
.overview-banner :deep(.custom-slick-arrow:before) {
  display: none;
}
.overview-banner :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.h3c-swiper-slide-wrapper {
  //width: 1200px;
  display: flex;
  justify-content: space-between;
  padding: 70px 32px 0;
}

.h3c-swiper-slide-prev {
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  background-image: url('../../../assets/images/icon-left.png');
  background-size: 10px 18px;
  background-repeat: no-repeat;
  left: 0;
  top: 50%;
  background-position: 45% 50%;
}
.h3c-swiper-slide-next {
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  background-image: url('../../../assets/images/icon-right.png');
  background-size: 10px 18px;
  background-repeat: no-repeat;
  right: 0;
  top: 50%;
  background-position: 55% 50%;
}
.banner-right1 {
  position: relative;
  transition: all 0.3s;
  /*background: url('../../../assets/images/guestBac.png') center center no-repeat;*/
  width: 286px;
  height: 398px;
}
.banner-right1:hover {
  transform: translateY(-20px);
  .inside-di {
    background-image: url('../../../assets/images/guestBac1.png');
  }
}
.inside {
  position: absolute;
  z-index: -1;
  top: 73px;
  right: 0px;
}
.inside-di {
  //margin-left: 30px;
  width: 255px;
  height: 370px;
  background-image: url('../../../assets/images/guestBac.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position-y: 100%;
  position: absolute;
  right: 0;
  &:hover {
    background-image: url('../../../assets/images/guestBac1.png');
  }
  .img-background {
    width: 255px;
    height: 370px;
  }
}
.banner-content {
  padding: 5px 10px 15px 10px;
  width: 240px;
  height: 140px;
  background: linear-gradient(180deg, #128ab3 0%, #004a80 100%);
  position: absolute;
  left: 0;
  bottom: 0;
  //display: flex;
  flex-wrap: wrap;
}
.banner-content-invited {
  padding: 5px 10px 15px 10px;
  width: 250px;
  height: 200px;
  background: linear-gradient(180deg, #128ab3 0%, #004a80 100%);
  position: absolute;
  left: 0;
  bottom: 0;
  //display: flex;
  flex-wrap: wrap;
}
.name {
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  width: 100%;
}
.company {
  font-weight: 400;
  color: #ffffff;
  font-size: 16px;
}
.ant-carousel .slick-dots {
  top: 400px;
}
.ant-carousel .slick-dots li {
  width: 5px;
  height: 5px;
}
.overview-banner /deep/ .ant-carousel .slick-dots li.slick-active button {
  margin-top: 55px;
  background: linear-gradient(to right, #4dd2ff, #bfffff, #4dff89);
  width: 24px;
  height: 8px;
}
.overview-banner /deep/ .ant-carousel .slick-dots li button {
  margin-top: 55px;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 8px;
  opacity: 0.2;
}
.carousel-banner {
  position: relative;
}
.arrow-left {
  position: absolute;
  left: 1230px;
}
.icon-left {
  position: absolute;
  left: 19px;
  top: 17px;
}
.icon-right {
  position: absolute;
  left: 22px;
  top: 17px;
}
.arrow-right {
  position: absolute;
  left: 1230px;
}
.overview-meeting {
  width: 1200px; /* no-pxtorem */
  position: relative;
  margin: 0 auto;
  padding-top: 140px;
  white-space: nowrap;
  .meeting-img-box {
    width: 100%;
    height: 200px;
    position: relative;
    overflow: hidden;
    .meeting-img-wrapper {
      transition: all 0.3s;
      //position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 0;
      .previous-img {
        width: 285px;
        height: 200px;
        cursor: pointer;
        z-index: 1;
      }
      img + img {
        margin-left: 20px;
      }
    }
  }
  .meeting-btn {
    width: 1360px;
    position: absolute;
    height: 200px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    .meeting-btn-prev {
      cursor: pointer;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.2);
      background-image: url('../../../assets/images/icon-left.png');
      background-position: 45% 50%;
      background-size: 10px 18px;
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
      position: absolute;
      left: 0;
      transform: translateY(-50%);
      z-index: 10;
    }
    .meeting-btn-next {
      cursor: pointer;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.2);
      background-image: url('../../../assets/images/icon-right.png');
      background-position: 55% 50%;
      background-size: 10px 18px;
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
      position: absolute;
      right: 0;
      transform: translateY(-50%);
      z-index: 10;
    }
  }
}
.previous-img {
  cursor: pointer;
}
.ooverview-shopp ing {
  width: 1200px; /* no-pxtorem */
  position: relative;
  margin: 0 auto;
  padding-top: 100px;
}
.meetingPrevious {
  padding-bottom: 100px;
}
.meeting {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.shopping-content {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.map-img {
  img {
    width: 600px;
    height: 280px;
  }
  //width: 860px;
  //height: 260px;
}
.shopping-img {
  img {
    width: 1200px;
    height: 142px;
  }
}
// todo
.meeting-bac {
  position: absolute;
  top: 0px;
  left: 0;
  // left: 11px;
  img {
    user-select: none;
    user-drag: none;
    width: 100%;
    // width: 600px;
    // height: 280px;
  }
}
.partner-size {
  width: 220px;
  height: 64px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid transparent;
}
.partner {
  display: flex;
  flex-wrap: wrap;
  //grid-gap: 20px;
}
.partner-circulate {
  //flex-grow: 1;
  box-sizing: border-box;
  padding: 10px 10px;
}
.carousel-banner /deep/.ant-carousel .slick-next:hover {
  /*background: none;*/
  /*pointer-events: none;*/
}
/* .carousel-banner /deep/  */
.ant-carousel .slick-prev:hover,
.ant-carousel .slick-next:hover,
.ant-carousel .slick-prev:focus,
.ant-carousel .slick-next:focus {
  /*color: none;*/
  /*background: none;*/
  /*background: transparent;*/
}

.overview-banner .custom-slick-arrow:hover {
  /* opacity: 0.5; */
  /*pointer-events: none;*/
}

.overview-banner /deep/ .slick-arrow.custom-slick-arrow {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background: #ffffff;
}
.footer-border {
  width: 1200px; /* no-pxtorem */
  position: relative;
  padding: 30px 0;
  margin: 0 auto;
  /*border-style: solid;*/
  /* 布局后最底下的底纹再打开 */
  /* background: linear-gradient(to right, #ffffff 10%, #ffffff 0%); */

  /* 这个background不对，后续需要换成白色  */
  /*background: linear-gradient(to right, #070a11 100%, #0f1a4d 100%);*/
}
.overview-banner-copyright {
  width: 900px;
  position: relative;
  padding: 30px 0;
  margin: 0 auto;
}
.main-content-wrapper-footer {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.15);
  height: 140px;
}
.main-content-wrapper-copyright {
  width: 100%;
  height: 80px;
  background: #000000;
  opacity: 1;
}
// todo
.meeting-address {
  padding: 30px;
  background-image: url('../../../assets/images/address.png');
  background-size: 100% 100%;
  height: 280px;
  position: relative;
  display: flex;
  width: 50%;
  // justify-content: center;
  align-items: center;
  // margin-left: 20px;
  .download-btn {
    position: absolute;
    top: 15px;
    right: 30px;
    border-radius: 10px;
    background-color: #4d85ff;
    padding: 12px 40px;
    font-size: 20px;
    color: #fff;
    z-index: 3;
    display: none;
    cursor: pointer;
  }
}

.meeting-address-right {
  background-image: url('../../../assets/images/map.png');
  //width: 310px;
  // height: 280px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // position: absolute;
  // top: 0px;
  // right: 6%;
  // margin-right: 10px;
  .canhui-data {
    margin-top: 16px;
    margin-bottom: 16px;
  }
}
.meeting-content {
  z-index: 2;
  //width: 250px;
  margin-left: 10px;
}
.downloadStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .meeting-left {
    cursor: pointer;
    padding: 8px 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ffffff;
    .downloadIcon {
      width: 20px;
      height: 20px;
    }
    .download {
      margin-left: 8px;
    }
  }
}
.meeting-addressText {
  font-size: 28px;
  font-weight: 400;
}
.meeting-addressData {
  display: flex;
  font-size: 18px;
  font-weight: 400;
  justify-content: left;
  align-items: center;
  //margin-top: 40px;
}
.meeting-addressView {
  font-size: 18px;
  font-weight: 400;
  //margin-top: 20px;
  display: flex;
  justify-content: left;
  align-items: center;
  .meeting-address-text {
    white-space: normal;
  }
  .reservation-btn {
    //z-index: 20;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 50px;
    // position: absolute;
    left: 50px;
    //bottom: 141px;
    font-size: 20px;
    background: linear-gradient(90deg, #0a97c7 0%, #00cccc 66%, #27d990 100%);
  }
}
.meeting-icon {
  margin-right: 10px;
  width: 18px;
  height: 22px;
}
.meeting-icon-time {
  margin-right: 10px;
  width: 22px;
  height: 22px;
}

.schedule-bac {
  position: relative;
  background-image: url('../../../assets/images/schedule-bac2.png');
  background-size: contain;
  background-repeat: no-repeat;
  //background-position: 0px 247px;
  //padding-bottom: 100px;
}
.schedule-img {
  position: absolute;
  top: 210px;
  left: 0px;
}
.modalStyle /deep/ .ant-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
}
.succeed-but {
  width: 120px;
  height: 40px;
  background: linear-gradient(90deg, #0a97c7 0%, #00cccc 50%, #27d990 100%);
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  line-height: 36px;
  margin: 0 auto 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attention {
  font-size: 20px;
  font-weight: 400;
  color: #4c4948;
  line-height: 36px;
  margin-bottom: 30px;
  margin-top: 80px;
}
.checkOut {
  width: 90px;
  background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.shopping-content {
  position: relative;
  .shoppingOne {
    font-size: 24px;
  }
  .shoppingTwo {
    font-size: 16px;
  }
  .shopping-main {
    position: absolute;
    top: 20%;
    right: 80px;
  }
}
.overview-col2 {
  //width: 240px;
  padding-right: 10px;
  .col-3 {
    width: 250px;
  }
}
.cancel {
  position: absolute;
  right: 8px;
  top: 10px;
}
.bianju {
  margin-left: 27px;
}
.dezhi-content {
}
.meeting-address-invite {
  display: flex;
  white-space: normal;
  .fuhao-invite {
    margin-right: 20px;
  }
}
.fuhao {
  margin-right: 20px;
  color: #e60012;
}
.canhui-right {
  //margin-bottom: 75px;
  padding-top: 30px;
  display: flex;
  .reservation-Done {
    color: #ffffff;
    background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
    border-radius: 0px 0px 0px 0px;
    //cursor: not-allowed; /* 光标变为无效符号 */
    //pointer-events: none; /* 禁止用户触发事件 */
  }
}
</style>
